module.exports = __webpack_public_path__ + "static/img/default2.92231f04.png";